import React from 'react';
import { Link } from 'react-router-dom';
import { PILLAR_NAV } from '../data/productCatalog';
import { COMPANY, ADDRESSES, BROCHURE_PDF } from '../data/siteContent';

const Footer = () => {
  return (
    <footer className="bg-brand-900 text-white border-t border-brand-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div className="col-span-1 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <img src="/images/logo.png" alt="Sai Vikas Coatings Private Limited Logo" className="h-8 w-auto object-contain" />
              <span className="font-heading font-bold text-lg leading-tight">{COMPANY.legalName}</span>
            </div>
            <p className="text-brand-200 text-sm leading-relaxed">
              Manufacturer of SV Bond and applicator of specified coating systems for industrial and hygienic floors.
            </p>
            <div className="mt-4">
              <h4 className="font-bold text-white mb-1 text-sm">Head office</h4>
              <p className="text-brand-200 text-sm leading-relaxed">{ADDRESSES.puneOffice}</p>
            </div>
          </div>

          <div>
            <h4 className="font-bold text-white mb-4">Products</h4>
            <ul className="space-y-2 text-sm text-brand-200">
              {PILLAR_NAV.map((p) => (
                <li key={p.slug}>
                  <Link to={`/products/${p.slug}`} className="hover:text-brand-300 transition-colors">
                    {p.title}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/products" className="hover:text-brand-300 transition-colors font-semibold">
                  All categories
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-white mb-4">Company</h4>
            <ul className="space-y-2 text-sm text-brand-200">
              <li>
                <Link to="/services" className="hover:text-brand-300 transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/industries" className="hover:text-brand-300 transition-colors">
                  Industries
                </Link>
              </li>
              <li>
                <Link to="/certifications" className="hover:text-brand-300 transition-colors">
                  Certifications & Awards
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="hover:text-brand-300 transition-colors">
                  Gallery
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-white mb-4">Connect</h4>
            <ul className="space-y-2 text-sm text-brand-200">
              <li>
                <Link to="/contact" className="hover:text-brand-300 transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <a href={BROCHURE_PDF} className="hover:text-brand-300 transition-colors" target="_blank" rel="noopener noreferrer">
                  Brochure (PDF)
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-brand-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-brand-300 text-sm">© {new Date().getFullYear()} {COMPANY.legalName}. All rights reserved.</p>
          <div className="flex flex-wrap justify-center gap-4 text-sm text-brand-300">
            <Link to="/contact" className="hover:text-brand-100">
              Privacy
            </Link>
            <Link to="/contact" className="hover:text-brand-100">
              Terms
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
